import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { default as _ } from 'underscore'
import { FormGroup, FormControl, Button } from 'react-bootstrap'
import { Card, CardHeader, CardBody, Collapse } from 'reactstrap'
import moment from 'moment'
import uuid from 'uuid'

import { SATURDAY, SUNDAY } from '../../../constants/weekDays'
import ClientRegistration from '../clientRegistration'
import CarData from '../carData'
import { switchCheckoutContent, getCurrentUser, cleanCheckoutContentStore, loadClientByPlate, sendPickupMessage } from './actions'
import Appointment from '../appointment'
import Services from '../services'
import CarMakeModelDialog from './carMakeModelDialog'
import { fetchMainServices } from './../../../catalogue'
import { searchServices } from './../services/actions'
import { submitCheckoutForm } from './../clientRegistration/actions'
import { generateDni } from './../../../utils'
import { configuration } from '../../../configuration'

import './styles.css'

class CheckoutContent extends React.Component {
  static propTypes = {
    checkoutContentStore: PropTypes.shape({
      activeItems: PropTypes.arrayOf(PropTypes.string),
      currentUser: PropTypes.object
    }),
    appointmentStore: PropTypes.shape(),
    carDataStore: PropTypes.shape(),
    personalDataStore: PropTypes.shape(),
    carDataForm: PropTypes.shape({
      values: PropTypes.object,
    }),
    carPlateForm: PropTypes.shape({
      values: PropTypes.object,
    }),
    getCurrentUser: PropTypes.func.isRequired,
    checkoutStore: PropTypes.object
  }

  constructor(props) {
    super(props);

    this.validAppointmentData = this.validAppointmentData.bind(this);
    this.validCarDataData = this.validCarDataData.bind(this);
    this.validServiceData = this.validServiceData.bind(this);
    this.switchCheckoutContent = this.switchCheckoutContent.bind(this);
    this.submitBudgetData = this.submitBudgetData.bind(this);
  }

  state = {
    serviceSearch: "",
    sendPickupMessage: false,
  }

  validServiceData() {
    const items = this.props.shoppingCart.items || [];
    return items.length > 0 || this.props.checkoutStore.validNonForfaitToken;
  }

  validAppointmentData() {
    const appointmentData = this.props.appointmentStore.appointmentData || {};
    const tempAppointmentData = this.props.appointmentStore.tempAppointmentData || {};
    const forfait = this.props.shoppingCart.forfait;
    const addressForm = this.props.addressForm.values || {}
    // Set the time to 0 to compare strictly dates
    const _currentDate = new Date();
    const currentDate = moment({
      year: _currentDate.getFullYear(),
      month: _currentDate.getMonth(),
      day: _currentDate.getDate()
    });
    const tempWeekend = moment(tempAppointmentData.date).isoWeekday() === SATURDAY || moment(tempAppointmentData.date).isoWeekday() === SUNDAY;
    const weekend = moment(appointmentData.date).isoWeekday() === SATURDAY || moment(appointmentData.date).isoWeekday() === SUNDAY;

    //Set time to 00:00:00:00
    currentDate.startOf('day');
    const validAppointmentData = (
      appointmentData
      && appointmentData.date && !moment(appointmentData.date).isBefore(currentDate) && !weekend
      && appointmentData.scheduleRange
    );

    const validTempData = (
      tempAppointmentData
      && tempAppointmentData.date && !moment(tempAppointmentData.date).isBefore(currentDate) && !tempWeekend
      && tempAppointmentData.scheduleRange
    );

    return (
      validAppointmentData
      || validTempData || (!forfait && !this.props.checkoutStore.validNonForfaitToken)
    )
      && this.validServiceData();
  }

  validCarDataData(filter) {
    const carDataData = this.props.carDataStore.carDataData;
    const carDataFormValues = this.props.carDataForm.values;
    const carPlateFormValues = this.props.carPlateForm.values;

    const validCarDataData = carDataData
      && carDataData.carPlate && carDataData.carPlate !== ''
      && (
        (
          carDataData.carYear && carDataData.carYear !== ''
          && carDataData.carModel && carDataData.carYear !== ''
          && carDataData.carMake && carDataData.carYear !== ''
          && carDataData.carEngine && carDataData.carEngine !== ''
        )
        || carDataData.technicalCard
      );
    const validCarDataFormValues = carDataFormValues
      && (
        (
          carDataFormValues.carMake && carDataFormValues.carMake !== ''
          && carDataFormValues.carModel && carDataFormValues.carModel !== ''
          && carDataFormValues.carYear && carDataFormValues.carYear !== ''
          && carDataFormValues.carEngine && carDataFormValues.carEngine !== ''
        )
        || carDataFormValues.technicalCard
      );

    switch (filter) {
      case 'formOnly':
        return validCarDataFormValues;
      case 'both':
        return (validCarDataData || (validCarDataFormValues)) && this.validAppointmentData()
      case 'dataOnly':
      default:
        return validCarDataData && this.validAppointmentData();
    }
  }

  switchCheckoutContent(content) {
    this.props.switchCheckoutContent(content);
  }

  componentWillUnmount() {
    this.props.cleanCheckoutContentStore(['currentUser']);
  }

  handleServiceSearchChange = ({ target: { value } }) => {
    this.setState({
      serviceSearch: value
    })

    this.searchServices(value.length > 1 ? value.length : '')
  }

  handleSearchPerKm = ({ target: { value } }) => {
    this.setState({
      serviceSearch: value,
    })
  }

  handleClickSearch = () => {
    this.searchServices(Intl.NumberFormat("de-DE").format(this.state.serviceSearch))
  }

  handleKeyPressSearch = (event) => {
    if (event.key === 'Enter') {
      this.searchServices(this.state.serviceSearch)
    }
  }

  searchServices = (value) => {
    if (value === "") {
      this.props.fetchMainServices(this.props.carDataStore.carDataData);
    } else {
      this.props.searchServices(value)
    }
  }

  recallsAsBudgetLines = () => {
    return this.props.recalls.map(recall => {
      return {
        serviceId: uuid.v4(),
        price: 0,
        observations: 'Campaña gratuita',
        name: recall,
        noPaid: true,
        isAdditional: true
      }
    })
  }

  setTimeUnits = (budget) => {
    budget.budgetLines.forEach(service => {
      let uts = service.timeUnits ? service.timeUnits : 0
      if (typeof uts !== 'object') {
        service.timeUnits = {
          customTimeUnits: null,
          defaultServiceTimeUnits: uts,
          defaultWorkshopTimeUnits: null
        }
      }
    })

    return budget
  }

  submitBudgetData() {
    const carDataForm = this.props.carDataStore.carDataData ? this.props.carDataStore.carDataData : false;
    const shoppingCart = this.props.shoppingCart ? this.props.shoppingCart : false;
    const appointmentDataForm = (this.props.appointmentStore.selectedDate && this.props.appointmentStore.selectedTime)
      ? {
        selectedDate: this.props.appointmentStore.selectedDate,
        selectedTime: this.props.appointmentStore.selectedTime
      } : false;
    const clientDataForm = this.props.personalDataForm.values ? this.props.personalDataForm.values : false;
    const currentUser = (this.props.checkoutContentStore.currentUser !== null) ? this.props.checkoutContentStore.currentUser : null;
    const clientCarPlate = this.props.clientCarPlate;

    //TODO: por defecto pondré Syrsa para desarrollo.
    const autocareEmailHash = configuration().workshopEmailHash
    const mandatoryClientData = configuration().mandatoryClientData

    let clientData;
    let carData;
    let appointmentData;

    if (clientDataForm && currentUser !== null && currentUser.user) {
      clientData = {
        address: currentUser.user.address,
        city: currentUser.user.city,
        dni: currentUser.user.dni,
        email: currentUser.user.email,
        firstName: mandatoryClientData ? clientDataForm.clientName : currentUser.user.firstName,
        lastName: mandatoryClientData ? clientDataForm.clientSurname : currentUser.user.lastName,
        phone: mandatoryClientData ? clientDataForm.clientPhone : currentUser.user.phone,
        province: currentUser.user.province,
        street: currentUser.user.street,
        zipcode: currentUser.user.zipcode,
        emailForm: clientDataForm.clientEmail,
        fromWeb: true,
        overwriteData: mandatoryClientData,
        noEmailNotifications: false,
        noMobileNotifications: false,
      };

      carData = currentUser;
    } else if (clientDataForm && carDataForm) {

      clientData = {
        fromWeb: true,
        email: clientDataForm.clientEmail,
        phone: clientDataForm.clientPhone,
        firstName: clientDataForm.clientName,
        lastName: clientDataForm.clientSurname,
        dni: generateDni(),
        noEmailNotifications: false,
        noMobileNotifications: false,
      };
      carData = {
        engine: carDataForm.carEngine.split(",")[0],
        engineId: carDataForm.carEngine.split(",")[2],
        fuel: carDataForm.carEngine.split(",")[1],
        make: carDataForm.carMake,
        model: carDataForm.carModel,
        year: carDataForm.carYear,
        plate: clientCarPlate
      }
    } else {
      clientData = false;
      carData = false;
    }

    // Comprobar datos de appointment
    if (appointmentDataForm) {
      const advisors = this.props.appointmentStore.advisors;
      // cargar datos del appointment en appointmentData
      appointmentData = {
        advisorEmailHash: (advisors.length > 0) ? advisors[0].emailHash : '',
        date: appointmentDataForm.selectedDate,
        scheduleRange: appointmentDataForm.selectedTime,
        time: appointmentDataForm.selectedTime,
        zipcode: '',
        replacementVehicle: this.props.appointmentStore.replacementVehicle
      }
    } else {
      appointmentData = {
        date: undefined,
        scheduleRange: undefined,
        zipcode: '',
      }
    }

    const data = {
      client: clientData,
      appointment: appointmentData || {}, // TODO: HANDLE APPOINTMENT DATA
      car: carData,
    }

    let extras = shoppingCart.items.reduce((memo, item) => {
      let extras = _.where(item.extras, { activate: true }) || [];
      return memo.concat(extras);
    }, [])

    const payload = {
      autocareEmailHash,
      personalData: {
        ...data.client,
      },
      appointmentData: {
        ...data.appointment,
        noCallCenter: true
      },
      carData: {
        ...data.car,
        zipCode: (clientData.zipCode ? clientData.zipcode : ''),
        fuel: (carData.fuel ? carData.fuel : ''),
        engine: (carData.engine ? carData.engine : ''),
      },
      budgetLines: shoppingCart.items.concat(extras).concat(this.recallsAsBudgetLines()),
      repeatService: false,
      forfait: shoppingCart.forfait,
      recurrentUser: false,
      reasonForReject: null,
    }

    // Recorremos los budgetLines para enviar en el campo timeUnits la estructura que se espera en API
    this.setTimeUnits(payload)

    if (this.props.carDataStore.kilometres) {
      payload.carData.kilometres = this.props.carDataStore.kilometres;
    }

    if (shoppingCart !== false) {
      _.map(shoppingCart.items, (item) => {
        if (item.name === configuration().servicioRecogidaYEntrega && this.props.appointmentStore.pickupAddress !== null) {
          // servicio de recogida y entrega
          this.setState({
            sendPickupMessage: true
          })
        }
      })
    }

    this.props.submit(payload, autocareEmailHash, (responseDataBudgetId) => {
      // Enviar mensaje si se ha solicitado servicio de Recogida y Entrega
      if (this.state.sendPickupMessage) {
        const text = "Se ha solicitado el servicio de Recogida y Entrega para la dirección: " + this.props.appointmentStore.pickupAddress + ".";
        this.props.sendPickupMessage(responseDataBudgetId, text, appointmentDataForm, configuration());
      } else {
        this.handleRedirect(appointmentDataForm)
      }
    });
  }

  handleRedirect = (isAppointment) => {
    let url
    if (this.props.appointmentStore.replacementVehicle) {
      url = configuration().redirects.graciasReplacementVehicle
    } else if (isAppointment) {
      url = configuration().redirects.graciasCita
    } else {
      url = configuration().redirects.graciasPpto
    }
    window.location.assign(url);
  }

  render() {
    const checkoutContentStore = this.props.checkoutContentStore;
    const _activeKey = checkoutContentStore.activeKey;
    const activeKey = _activeKey;

    const mainServiceKm = this.props.mainServiceKm;

    const carDataHeader = <span><span className="custom-circle">0</span>Datos del vehículo</span>;
    const servicesHeader = <span><span className="custom-circle">1</span>Servicio</span>;
    const servicesHeaderSearch =
      <div className="row">
        {configuration().brandName != 'Mazda'
          ?
          <div className="col-6 search-text"><span style={{ verticalAlign: 'middle' }}>Buscar servicios:</span></div>
          : null
        }
        <div className={configuration().brandName == 'Mazda' ? "col-12" : "col-6"}>
          <div className="serviceSearch inner-addon left-addon">
            <FormGroup controlId="searchService" style={{ marginBottom: 0 }}>
              <FormControl bsClass="search-rectangle" placeholder={configuration().brandName == 'Mazda' ? "Buscar Servicios" : null} name="serviceSearch" type="text" onChange={this.handleServiceSearchChange} />
            </FormGroup>
            <span className="search-icon" style={{ maxWidth: "30px", margin: "-3px 15px -3px 15px", cursor: "pointer" }} onClick={this.searchServices}>
              <i className="fa fa-search" aria-hidden="true"></i>
            </span>
          </div>
        </div>
      </div>
    const appointmentHeader = <span><span className="custom-circle">2</span>Cita</span>;
    const personalDataHeader = <span><span className="custom-circle">3</span>Datos personales</span>;

    let renderSearchInput = false;

    let renderServices = '';
    let renderAppointment = '';
    let renderCarData = '';
    let renderPersonalData = '';

    let serviceClass = 'panelContainer disable-accordion-panel';
    let serviceClickHandler = () => { };
    let appointmentClass = 'panelContainer disable-accordion-panel';
    let appointmentClickHandler = () => { };
    let carDataClass = 'panelContainer disable-accordion-panel';
    let carDataClickHandler = () => { };
    let personalDataClass = 'panelContainer disable-accordion-panel';
    let personalDataClickHandler = () => { };

    let renderMainServiceKmSearch = null;
    if (mainServiceKm === true && !this.props.catalogue.customService) {
      renderMainServiceKmSearch =
        <div className="rectangle-Km"
          style={{ backgroundColor: configuration().clientSearchKmColor }}>
          <div className="col-sm-12 mantenimiento-programado">
            Calcular mantenimiento programado
          </div>
          <div className="row" style={{ marginTop: 15, paddingBottom: 15 }}>
            <FormGroup bsClass="col-sm-12" controlId="searchMantenimientoKm">
              <FormControl
                bsClass="input-Km"
                style={{ borderColor: configuration().clientColor }}
                type="number"
                placeholder="Introducir kms"
                onKeyPress={this.handleKeyPressSearch}
                onChange={this.handleSearchPerKm}
              />
              <Button
                className="jump btn-buscar-km"
                style={{ backgroundColor: configuration().clientColor }}
                type="submit"
                onClick={this.handleClickSearch}
              >
                <span className="labelFlip1 span-km">
                  BUSCAR
                </span>
                <span className="labelFlip2" style={{ visibility: 'hidden' }}>BUSCAR</span>
              </Button>
            </FormGroup>
          </div>
        </div>
    } else {
      renderMainServiceKmSearch = null;
    }

    switch (activeKey) {
      case 'carData':
        renderCarData = <CarData switchCheckoutContent={this.switchCheckoutContent} validCarDataData={this.validCarDataData} />;
        carDataClass = 'panelContainer';
        carDataClickHandler = () => this.switchCheckoutContent('carData');
        break;
      case 'services':
        carDataClass = 'panelContainer';
        carDataClickHandler = () => this.switchCheckoutContent('carData');
        serviceClass = 'panelContainer';
        serviceClickHandler = () => this.switchCheckoutContent('services');
        renderServices = <Services car={(this.props.carDataStore && this.props.carDataStore.carDataData) || null} />;
        renderSearchInput = true;
        break;
      case 'appointment':
        carDataClass = 'panelContainer';
        carDataClickHandler = () => this.switchCheckoutContent('carData');
        serviceClass = 'panelContainer';
        serviceClickHandler = () => this.switchCheckoutContent('services');
        renderAppointment = <Appointment switchCheckoutContent={this.switchCheckoutContent} validAppointmentData={this.validAppointmentData} />;
        appointmentClass = 'panelContainer';
        appointmentClickHandler = () => this.switchCheckoutContent('appointment');
        break;

      case 'personalData':
        carDataClass = 'panelContainer';
        carDataClickHandler = () => this.switchCheckoutContent('carData');
        serviceClass = 'panelContainer';
        appointmentClass = this.props.appointmentStore.beforeBudget ? 'panelContainer' : 'panelContainer disable-accordion-panel';
        serviceClickHandler = () => this.switchCheckoutContent('services');
        renderPersonalData = <ClientRegistration switchCheckoutContent={this.switchCheckoutContent} submitBudgetData={this.submitBudgetData} />;
        personalDataClass = 'panelContainer';
        break;

      default:
        renderServices = <Services car={(this.props.carDataStore && this.props.carDataStore.carDataData) || null} />;
        break;
    }

    return (
      <React.Fragment>
        <span className="accordion-panel">
          <Card style={{ marginBottom: '5px' }} className={carDataClass}>
            <CardHeader onClick={carDataClickHandler}>{carDataHeader}</CardHeader>
            <Collapse isOpen={activeKey === "carData"}>
              <CardBody>
                {renderCarData}
              </CardBody>
            </Collapse>
          </Card>
          <Card style={{ marginBottom: '5px' }} className={serviceClass} disabled>
            <CardHeader onClick={serviceClickHandler}>
              <div className="row">
                <div className="col-12 col-sm-4">
                  {servicesHeader}
                </div>
                <div className="col-12 col-sm-8">
                  {(renderSearchInput === true)
                    ? servicesHeaderSearch
                    : null}
                </div>
              </div>
            </CardHeader>
            <Collapse isOpen={activeKey === "services"}>
              <CardBody style={{ padding: '0px' }}>
                {renderMainServiceKmSearch}
                {renderServices}
              </CardBody>
            </Collapse>
          </Card>
          <Card style={{ marginBottom: '5px' }} className={appointmentClass}>
            <CardHeader onClick={appointmentClickHandler}>{appointmentHeader}</CardHeader>
            <Collapse isOpen={activeKey === "appointment"}>
              <CardBody>
                {renderAppointment}
              </CardBody>
            </Collapse>
          </Card>
          <Card style={{ marginBottom: '5px' }} className={personalDataClass}>
            <CardHeader onClick={personalDataClickHandler}>{personalDataHeader}</CardHeader>
            <Collapse isOpen={activeKey === "personalData"}>
              <CardBody>
                {renderPersonalData}
              </CardBody>
            </Collapse>
          </Card>
        </span>
        <CarMakeModelDialog />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  checkoutContentStore: state.checkout.checkoutContent,
  appointmentStore: state.checkout.appointment,
  carDataStore: state.checkout.carData,
  personalDataStore: state.checkout.personalData,
  carDataForm: state.form.carDataForm || {},
  shoppingCart: state.checkout.shoppingCart || {},
  carPlateForm: state.form.carPlateForm || {},
  checkoutStore: state.checkout.checkoutRoot,
  addressForm: state.form.addressForm || {},
  mainServiceKm: state.catalogue.mainServiceKm,
  catalogue: state.catalogue,
  personalDataForm: state.form.personalDataForm || {},
  clientCarPlate: state.checkout.carData.clientCarPlate,
})

const bindActions = dispatch => ({
  switchCheckoutContent: content => dispatch(switchCheckoutContent(content)),
  getCurrentUser: () => dispatch(getCurrentUser()),
  cleanCheckoutContentStore: props => dispatch(cleanCheckoutContentStore(props)),
  fetchMainServices: (zipcode) => dispatch(fetchMainServices(zipcode)),
  searchServices: query => dispatch(searchServices(query)),
  loadClientByPlate: plate => dispatch(loadClientByPlate(plate)),
  submit: (data, autocareEmailHash, cb) => dispatch(submitCheckoutForm(data, autocareEmailHash, cb)),
  sendPickupMessage: (budgetId, text, appointmentDataForm, config) => dispatch(sendPickupMessage(budgetId, text, appointmentDataForm, config)),
})

export default connect(mapStateToProps, bindActions)(CheckoutContent)



// WEBPACK FOOTER //
// ./src/workflow/checkout/checkoutContent/index.js